/**
 * Generic map configuration
 * Provider-agnostic settings that work with any map implementation
 */

// Map configuration
export const mapConfig = {
  // Default map settings
  defaultZoom: 13,
  minZoom: 3,
  maxZoom: 18,

  // Default center (San Diego)
  defaultCenter: [32.7157, -117.1611] as [number, number],

  // Search radius settings (in meters)
  defaultRadius: 5000, // 5km
  minRadius: 500,      // 500m
  maxRadius: 50000,    // 50km
};

// Sport type to color mapping (used by all providers)
export const sportTypeColors: Record<string, string> = {
  gym: '#FF6B6B',
  stadium: '#4ECDC4',
  'sports-hall': '#45B7D1',
  park: '#96CEB4',
  court: '#FFEAA7',
  pool: '#74B9FF',
  field: '#A29BFE',
  arena: '#FD79A8',
  club: '#FDCB6E',
  default: '#6C5CE7',
};